import PropTypes from 'prop-types'
import React from 'react'
import createEmptyRichText from 'components/RichText/utils/createEmptyRichText'
import onClickOutside from 'react-onclickoutside'
import AddChecklistItemForm from './AddChecklistItemForm'

export class AddChecklistItem extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    boardId: PropTypes.number.isRequired,
    className: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    disabledOnClickOutside: PropTypes.bool
  }

  handleClickOutside () {
    this.close()
  }

  close = () => {
    if (!this.props.disabledOnClickOutside) {
      this.props.onClose()
    }
  }

  render () {
    let {
      id,
      boardId,
      className,
      onSubmit
    } = this.props

    return (
      <div
        className={className}
        style={{ paddingLeft: 20 }}
      >
        <AddChecklistItemForm
          form={'addChecklistItem-' + id}
          id={id}
          boardId={boardId}
          initialValues={{
            name: createEmptyRichText()
          }}
          onSubmit={onSubmit}
          onCancelClick={this.close}
        />
      </div>
    )
  }
}

export default onClickOutside(AddChecklistItem)
